module.exports = {
      id: "longform-usage",
      viewBox: "0 0 12.6 15.258",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#longform",
      toString: function () {
        return this.url;
      }
    }